module.exports = __webpack_public_path__ + "static/media/amity-lodge-motel-queenstown.8056f90b.jpg";